/**
 * routers
 * 更多关于Router的使用，请参考以下教程
 * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
 */

// 资金管理
import TemplateIndex from './template/Index';
import TemplateAdd from './template/PageAdd';
import TemplateEdit from './template/PageEdit';

const router = {
  path: 'workflow',
  breadcrumbName: '工作流',
  childRoutes: [
    {
      path: 'template',
      breadcrumbName: '工作流模板设置',
      indexRoute: { component: TemplateIndex },
      childRoutes: [
        {
          path: 'add',
          breadcrumbName: '工作流模板添加',
          component: TemplateAdd,
        },
        {
          path: 'edit/:uuid',
          breadcrumbName: '工作流模板修改',
          component: TemplateEdit,
        },
      ],
    },
  ],
};

export default router;



// WEBPACK FOOTER //
// ./src/components/boss/workflow/router.js